import { render, staticRenderFns } from "./MarketplaceTabs.vue?vue&type=template&id=69d326df"
import script from "./MarketplaceTabs.vue?vue&type=script&lang=js"
export * from "./MarketplaceTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports